// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2RtkL","label":"Radio_label__3Bcf-","checkMark":"Radio_checkMark__N-ZnK","disabled":"Radio_disabled__3yd5p"};